import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function EditTransactionCategory(props) {
    const { t } = useTranslation();
    const transactionType = props.match.params.type.toLowerCase();
    const transactionTypeTitle = transactionType.charAt(0).toUpperCase() + transactionType.slice(1);
    const name = useRef();
    const notes = useRef();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);
    const [transactionCategory, setTransactionCategory] = useState({});
    const id = props.match.params.id;

    useEffect(() => {
        axios.get(API_URL + 'transaction-category/' + id).then((response) => {
            const transactionCategoryData = response.data?.data;
            if (response.data?.status === true && transactionCategoryData && typeof transactionCategoryData === 'object' && !Array.isArray(transactionCategoryData)) {
                setTransactionCategory(transactionCategoryData);

            } else {
                setTransactionCategory({});
                alertify.error(response.data?.message || "Something went wrong. Try again!");
                return null;
            }
        }).catch((error) => {
            setTransactionCategory({});
            alertify.error(error.response?.data?.message || "Something went wrong. Try again!");
        })
    }, [id]);

    const updateTransactionCategoryHandler = (e) => {
        e.preventDefault();
        setDisabled(1);
        setIconDisabled(0);
        axios.post(API_URL + "transaction-category/update",
            {
                id: transactionCategory.id,
                name: name.current.value,
                notes: notes.current.value,
            }
        ).then((response) => {
            setDisabled(0);
            setIconDisabled(1);
            if (response.data?.status === true) {
                alertify.success(response.data.message);

                props.history.push("/transaction-category/list/"+transactionType);
            } else {
                alertify.error(response.data?.message || "Something went wrong. Try again!");
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error(error.response?.data?.message || "Something went wrong. Try again!");
        });
    }
    return (
        <Row>
            <Col md={12}>
                <Card>
                    <CardHeader title={`Edit ${transactionTypeTitle} Category`}>
                        <CardHeaderToolbar>
                            <Link to={'/transaction-category/list/'+transactionType} className="btn btn-primary btn-sm mx-3">
                                {transactionTypeTitle} {t("Category List")}
                            </Link>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>

                        <div className="mt-5">
                            <Form onSubmit={updateTransactionCategoryHandler}>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Name")}</Form.Label>
                                        <Form.Control ref={name} placeholder={t("Enter Transaction Category Name")}
                                                      defaultValue={transactionCategory.name}/>
                                    </Form.Group>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Notes")}</Form.Label>
                                        <Form.Control as="textarea" ref={notes} placeholder={t("Enter Transaction Category Notes")}
                                                      rows={5}
                                                      defaultValue={transactionCategory.notes}/>
                                    </Form.Group>
                                </Form.Row>
                                <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                    {t("Save")}
                                    <span
                                        dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                </Button>
                            </Form>

                        </div>

                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}
